import { render, staticRenderFns } from "./BudoNoticeBar.vue?vue&type=template&id=1be8950a"
import script from "./BudoNoticeBar.vue?vue&type=script&lang=js"
export * from "./BudoNoticeBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports